import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Brain, LogOut, User } from 'lucide-react';
import { ROUTES, ERROR_MESSAGES } from '../../utils/constants';
import { useAuth } from '../../contexts/AuthContext';

const NavigationButton = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? 'bg-white text-blue-600 shadow-sm'
        : 'text-gray-600 hover:text-gray-900'
    }`}
  >
    {label}
  </button>
);

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error(ERROR_MESSAGES.LOGOUT_FAILED, error);
    }
  };

  const navigationItems = [
    { path: ROUTES.HOME, label: 'Task Manager' },
    { path: ROUTES.PRIORITIES, label: 'Dashboard' }
  ];

  return (
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
          <div className="text-center sm:text-left">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center justify-center sm:justify-start">
              <Brain className="w-6 h-6 sm:w-7 sm:h-7 mr-2 sm:mr-3 text-blue-600 " />
              Smart Task Manager
            </h1>
            <p className="text-gray-600 text-sm ml-0 sm:ml-10 ">AI-powered priority assessment</p>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
            <div className="flex space-x-1 bg-gray-100 rounded-lg p-1 sm:w-auto justify-center">
              {navigationItems.map(({ path, label }) => (
                <NavigationButton
                  key={path}
                  path={path}
                  label={label}
                  isActive={isActive(path)}
                  onClick={() => navigate(path)}
                />
              ))}
            </div>

            <div className="flex items-center space-x-3">
              <div className="flex items-center text-sm text-gray-600">
                <User className="w-4 h-4 mr-2" />
                <span >{currentUser.displayName || currentUser.email}</span>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center text-sm text-gray-600 hover:text-red-600 transition-colors"
                title="Sign Out"
                path={ROUTES.LOGIN}
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;